import React from 'react';
import { IMAGES, painLines } from '../data/breakFreeContent';
export function PainSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="pain-title" data-id="element-139" data-mp="38y6q4n4nujhp">
      <div className="mx-auto grid max-w-5xl items-center gap-8 px-5 lg:grid-cols-[1fr_0.85fr] lg:gap-12" data-id="element-140" data-mp="2uyx7zhww9fb3">
        <div data-id="element-141" data-mp="2yyz8vout24pb">
          <h2 id="pain-title" className="font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-142" data-mp="2yyfrc992hibt">
            How much longer do you want to live like this?
          </h2>

          <ul className="mt-6 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-143" data-mp="2ba6e3vpx62wa">
            {painLines.map(line => <li key={line} className="py-3 text-[14px] leading-snug text-ivory-200" data-id="element-144" data-mp="2g8hivs1cxn7n">
                {line}
              </li>)}
          </ul>

          <p className="mt-6 font-display text-lg leading-snug text-ivory-50 sm:text-xl" data-id="element-145" data-mp="22bufb6ewfysr">
            You don't need another person telling you to “just leave.”{' '}
            <span className="text-champagne" data-id="element-146" data-mp="3rlfzhv9qnb9b">You need to know HOW.</span>
          </p>
          <p className="mt-3 font-display text-lg italic leading-snug text-rose sm:text-xl" data-id="element-147" data-mp="3nknniu9hes9c">
            What if this were the moment the cycle finally started to change?
          </p>
        </div>

        <img src={IMAGES.recognition} alt="A composed woman walking away as he asks her to come back — the decision is hers" className="h-56 w-full object-cover object-center sm:h-72 lg:h-[22rem]" width={1200} height={900} data-id="element-148" data-mp="i1306b2zxfe" />
      </div>
    </section>;
}